import { Link } from "react-router-dom";
import { ReactComponent as Welldone } from "../../../media/welldone.svg";


const PaymentFailure = ({ trackId }) => {
  return (
    <div>
      <div className="main-container">
         <Welldone
          className="box50perc"
          alt="success payment"
        ></Welldone>
        <p className="heading-1 centerAlign green-1">
          پرداخت موفق
        </p>
        <p className="heading-1 centerAlign subject-1 grey-1 marginBottom5">{`کد رهگیری ${trackId}`}</p>
        <p className="subject-2 marginBottom10 grey-1 yekan">
          حالا میتونی یک برنامه فوق العاده برای تغذیه داشته باشی. کافیه کارتهای غذا رو
          ببینی و بزاریشون توی تقویم!
        </p>
        <Link
          to="/cards"
          className="marginBottom0-4r heading-3 fill-container b-green-1 radius1-5"
        >
          شروع برنامه ریزی
        </Link>
      </div>
    </div>
  );
};

export default PaymentFailure;
